import { api, endpoints } from "../api";
import { AxiosPromise } from "axios";
import { BaseApiPaging } from "api/types";
import { CreateDictionaryValues } from "pages/Dictionaries/DictionaryForm/CreateDictionaryForm";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string = "",
  orderBy: string = "",
): AxiosPromise<BaseApiPaging<DictionaryApi>> => {
  return api.get<BaseApiPaging<DictionaryApi>>(endpoints.DICTIONARIES.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (dictionaryId: number): AxiosPromise<DictionaryApi> => {
  return api.get<DictionaryApi>(endpoints.DICTIONARIES.GET_BY_ID(dictionaryId));
};

const fetchValue = (dictionaryValueId: number): AxiosPromise<DictionaryValueApi> => {
  return api.get<DictionaryValueApi>(endpoints.DICTIONARIES.GET_VALUE(dictionaryValueId));
};

const deleteDictionary = (dictionaryId: number): Promise<void> => {
  return api.delete(endpoints.DICTIONARIES.DELETE(dictionaryId));
};

const create = (data: CreateDictionaryValues): AxiosPromise<DictionaryApi> => {
  return api.post<DictionaryApi>(endpoints.DICTIONARIES.CREATE(), data);
};

const createValue = (dictionaryId: number, value: string): AxiosPromise<DictionaryValueApi> => {
  return api.post<DictionaryValueApi>(endpoints.DICTIONARIES.CREATE_VALUE(dictionaryId), { value });
};

const updateValue = (dictionaryId: number, id: number, value: string): AxiosPromise<number> => {
  return api.put<number>(endpoints.DICTIONARIES.UPDATE_VALUE(dictionaryId, id), { value });
};

const deleteValue = (dictionaryId: number, id: number): Promise<void> => {
  return api.delete(endpoints.DICTIONARIES.DELETE_VALUE(dictionaryId, id));
};

export const dictionariesApi = {
  fetch,
  fetchById,
  updateValue,
  delete: deleteDictionary,
  createValue,
  fetchValue,
  create,
  deleteValue,
};

export interface DictionaryValueApi {
  id: number;
  value: string;
}

export interface DictionaryApi {
  id: number;
  name: string;
  type: number;
  values: DictionaryValueApi[];
}
